module.exports = __webpack_public_path__ + "img/lavalife.3e686ff.png";